// @flow
import * as PropType from "prop-types";
import React, {useEffect, useRef, useState} from "react";
import LoadingSpinner from "./LoadingSpinner";

const LIButton = ({label, bgClass, disabled, large, medium, small, primary, secondary, fitHeight, floatRight, 
                      showBusy, submitType, onClick, faIcon, tooltip, widthPels, heightPels, 
                      show=true, subLabel, labelLeft=true, tabIndex=-1}) => {

    const [isDoubleClickTimerRunning, setIsDoubleClickTimerRunning] = useState(false);
    const [dbTimerRef:number, setDbTimerRef] = useState();

    const isComponentMounted = useRef(); // BUGFIX: 231130 - to stop react browser errors regarding mem-leaks
    
    useEffect( () => {
        isComponentMounted.current=true;
        return( () => {
            isComponentMounted.current=false;
            if(dbTimerRef) { // clear the timeout so we to stop react browser errors regarding mem-leaks
                clearTimeout(dbTimerRef);
            }
        });
    },[]);  // eslint-disable-line react-hooks/exhaustive-deps
    
    let sizeClass="li-font-medium"
    if(large) {
        sizeClass = "li-font-large";
    }
    else if(medium) {
        sizeClass = "li-font-medium";
    }
    else if(small) {
        sizeClass = "li-font-small";
    }

    let stdBtnClass="";
    if(primary) {
        stdBtnClass="li-primary";
    }
    else if(secondary) {
        stdBtnClass="li-secondary";
    }
    
    let heightClass="";
    if(fitHeight) {
        heightClass="li-button-height-auto";
    }

    let style=null
    if(floatRight) {
        style={position:'absolute',top:'10px',right:'-10px'};
    }
    if(widthPels) {
        style={...style, width:widthPels+'px'};
    }
    if(heightPels) {
        style={...style, minHeight:heightPels+'px'};
    }
    if(show===false) {
        style={...style, visibility:'hidden'};
    }

    function startDoubleClickTimer() {
        setDbTimerRef(setTimeout(() => {
            console.debug("double click timer reset");
            if(isComponentMounted.current) {
                setIsDoubleClickTimerRunning(false);    // allow another click after xx time
            }
        }, 250));
        setIsDoubleClickTimerRunning(true);
    }

    function handleOnClick(e) {
        if(onClick && !isDoubleClickTimerRunning) {
            startDoubleClickTimer();
            onClick(e);
        }
    }
    
    function showSubLabelIfRequired() {
        if(subLabel) {
            return(
                <div className="li-font-small text-center font-weight-normal">{subLabel}</div>
            );
        }
    }
    
    return(
        <button type={submitType?"submit":"button"}
                className={"li-button "+sizeClass+" "+(bgClass??"")+" "+stdBtnClass+" "+heightClass}
                data-toggle="tooltip" data-placement="auto" title={tooltip}
                style={style}
                disabled={disabled}
                tabIndex={tabIndex}
                onClick={(e)=>handleOnClick(e)}>
            {showBusy && <LoadingSpinner small/>}
            {!showBusy && labelLeft && <span>{label}</span>}
            {!showBusy && faIcon && <i className={faIcon}>&nbsp;</i>}
            {!showBusy && !labelLeft && <span>{label}</span>}
            {showSubLabelIfRequired()}

        </button>
    );
}

LIButton.propTypes = {
    label: PropType.string,
    bgClass: PropType.string,
    disabled: PropType.bool,
    onClick: PropType.func,
    large: PropType.bool,
    medium: PropType.bool,
    small: PropType.bool,
    fitHeight: PropType.bool,
    submitType: PropType.bool,
    primary: PropType.bool,
    secondary: PropType.bool,
    showBusy: PropType.bool,
    faIcon: PropType.string,
    tooltip: PropType.string,
    widthPels: PropType.number,
    heightPels: PropType.number,
    show: PropType.bool,
    subLabel: PropType.string,
    labelLeft: PropType.bool,
    tabIndex: PropType.number
}

export default LIButton;